export const ASSISTANT_SOURCES_RESPONSE_HEADING_TEXT =
  'I read these articles to help me create my response...';

export const ASSISTANT_KNOWLEDGE_SOURCES_RESPONSE_HEADING_TEXT =
  'GovernorHub Knowledge Articles:';

export const ASSISTANT_INTERCOM_SOURCES_RESPONSE_HEADING_TEXT =
  'GovernorHub Help Articles:';
